module.exports = __webpack_public_path__ + "images/input_email_icon.4b08c0f8.png";